import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiClock, FiDollarSign, FiTool } from 'react-icons/fi';

const servicePoints = [
  {
    title: 'Custom Projector Headlamp & Foglamp',
    description: 'Upgrade lampu utama dan foglamp dengan pendekatan yang lebih presisi untuk tampilan, karakter cahaya, dan hasil akhir yang lebih matang.',
    meta: 'Lighting upgrade'
  },
  {
    title: 'Coating & Detailing',
    description: 'Perawatan tampilan kendaraan untuk menjaga finish tetap bersih, tajam, dan terasa lebih proper saat dilihat dekat maupun jauh.',
    meta: 'Protection & finish'
  },
  {
    title: 'Body Kit & Lampu Aftermarket',
    description: 'Penyesuaian tampilan eksterior dan pilihan lampu aftermarket untuk kendaraan yang ingin tampil lebih kuat tanpa kehilangan arah desainnya.',
    meta: 'Exterior styling'
  },
  {
    title: 'Profender / YSS / JS1 / HKS / UR',
    description: 'Pilihan lini suspension dan performance parts untuk pelanggan yang membutuhkan setup lebih proper, lebih stabil, dan lebih sesuai kebutuhan build.',
    meta: 'Authorized product line'
  }
];

const Services = () => {
  return (
    <div className="min-h-screen pt-[72px]">
      <section className="bg-slate-950 py-24 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
<h1 className="mb-6 mt-6 text-4xl font-bold text-white md:text-6xl">
              Layanan Kami
            </h1>
            <p className="max-w-2xl text-xl leading-relaxed text-slate-300">
              Layanan difokuskan pada custom lampu, detailing, body kit, dan pilihan parts untuk kendaraan yang ingin tampil lebih terarah.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-16 max-w-3xl">
<h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">Layanan utama yang sekarang jadi fokus XSignature.</h2>
            <p className="mt-4 text-slate-600">
              Kontennya diarahkan untuk pelanggan yang mencari custom projector, foglamp, detailing, body kit, dan product line pilihan.
            </p>
          </div>

          <div className="border-t border-slate-200">
            {servicePoints.map((item, index) => (
              <div
                key={item.title}
                className={`grid gap-5 py-8 md:grid-cols-[220px_1fr_220px] md:items-start ${
                  index !== servicePoints.length - 1 ? 'border-b border-slate-200' : ''
                }`}
              >
                <div className="flex items-center gap-3 text-slate-900">
                  {index % 3 === 0 && <FiTool className="text-primary" size={18} />}
                  {index % 3 === 1 && <FiDollarSign className="text-primary" size={18} />}
                  {index % 3 === 2 && <FiClock className="text-primary" size={18} />}
                  <h3 className="text-xl font-semibold">{item.title}</h3>
                </div>
                <p className="max-w-2xl text-base leading-7 text-slate-600">{item.description}</p>
                <div className="text-sm font-medium text-slate-500 md:text-right">{item.meta}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-slate-200 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 md:grid-cols-[1fr_auto] md:items-end">
            <div className="max-w-2xl">
              <h2 className="text-3xl font-bold text-slate-950 md:text-4xl">Siap mulai project kendaraan Anda?</h2>
              <p className="mt-4 text-lg leading-7 text-slate-600">
              Konsultasikan kebutuhan build Anda dan pilih layanan yang paling sesuai.
              </p>
            </div>
            <Link to="/login" className="btn btn-primary px-8">
              Login & Konsultasi <FiArrowRight className="ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 
